"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_gefahrgut = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_gefahrgut = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAEhJREFUSEu1yKERADAMgMDM2/19Y1Bo8odibv3XB90k6CZBNwm6SdBNgm4SdJOgmwTdJOgmQTcJuknQTYJuEnSToJsE3aRLMwvzVMbXn+Pn3gAAAABJRU5ErkJggg==",
    iconSize: [30, 20],
});
